import React from 'react';

import { seoKeys } from '@travel/traveler-core/utils/seo';
import { isNotEmptyArray } from '@travel/utils';

import type { PriceRangeType } from '../FilterContainer';

export type FilterFormProps = {
  minPrice?: PriceRangeType;
  maxPrice?: PriceRangeType;
  starRating?: Array<string>;
  reviewRating?: Array<string>;
  features?: Array<string>;
  sortKey?: string;
  freeCancellation?: boolean;
};

function FilterForm(props: FilterFormProps) {
  const { minPrice, maxPrice, starRating, reviewRating, features, sortKey, freeCancellation } =
    props;

  return (
    <div data-testid="filterForm-wrapper">
      {minPrice !== null && minPrice !== undefined && (
        <input
          type="hidden"
          name="minPrice"
          data-testid="filterForm-minPrice-hiddenInput"
          value={String(minPrice)}
        />
      )}
      {maxPrice !== null && maxPrice !== undefined && (
        <input
          type="hidden"
          name="maxPrice"
          data-testid="filterForm-maxPrice-hiddenInput"
          value={String(maxPrice)}
        />
      )}
      {isNotEmptyArray(starRating) &&
        starRating.map((rating) => (
          <input
            key={rating}
            type="hidden"
            data-testid="filterForm-starRatings-hiddenInput"
            name="starRatings[]"
            value={rating}
          />
        ))}
      {isNotEmptyArray(reviewRating) &&
        reviewRating.map((score) => (
          <input
            key={score}
            type="hidden"
            data-testid="filterForm-reviewScores-hiddenInput"
            name="reviewScores[]"
            value={score}
          />
        ))}
      {freeCancellation && (
        <input
          type="hidden"
          data-testid="filterForm-freeCancellation-hiddenInput"
          name="freeCancellation"
          value={freeCancellation.toString()}
        />
      )}
      {isNotEmptyArray(features) && (
        <input
          type="hidden"
          name="features"
          data-testid="filterForm-features-hiddenInput"
          value={features?.join(',')}
        />
      )}
      {/* SEO Params */}
      {sortKey && (
        <input
          type="hidden"
          data-testid={`filterForm-${seoKeys.sortKey}-hiddenInput`}
          name={seoKeys.sortKey}
          value={sortKey}
        />
      )}
    </div>
  );
}

export default FilterForm;
